import React, { useState } from 'react';
import { Button } from './Button';
import { ImageLightbox } from './ImageLightbox';
import { useDispatch } from 'react-redux';
import { apiSlice } from '../../store/slices/apiSlice';

type OrderImageItem = {
  id: string;
  content_type: string;
  image_type: 'drawing' | 'cutout';
  feature: 'drilled_holes' | 'rounded_corners' | 'decorative_leads' | 'duplex_bar' | 'georgian_bar' | 'cutout' | 'quote_drawing' | string;
};

export const OrderImagesModal: React.FC<{ images: OrderImageItem[]; onClose: () => void }> = ({ images, onClose }) => {
  const dispatch = useDispatch<any>();
  const [lightboxUrl, setLightboxUrl] = useState<string | null>(null);
  const [lightboxType, setLightboxType] = useState<string | undefined>(undefined);

  const cap = (s: string) => s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  const featureLabel = (f: string) => ({
    drilled_holes: 'Drilled Holes',
    rounded_corners: 'Rounded Corners',
    decorative_leads: 'Decorative Leads',
    duplex_bar: 'Duplex Bar',
    georgian_bar: 'Georgian Bar',
    cutout: 'Cutout',
    quote_drawing: 'Quote Drawing',
  } as Record<string, string>)[f] || f.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

  const onView = async (image: OrderImageItem) => {
    try {
      const result: any = await dispatch(
        apiSlice.endpoints.presignOrderImageDownload.initiate({ imageId: image.id })
      ).unwrap();
      setLightboxUrl(result.url as string);
      setLightboxType(image.content_type);
    } catch {
      // swallow
    }
  };

  return (
    <div className="fixed inset-0 z-[55] bg-black/70 flex items-center justify-center" onClick={onClose}>
      <div className="bg-white rounded shadow-lg max-w-3xl w-full max-h-[90vh] overflow-auto" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between p-3 border-b">
          <div className="font-semibold text-sm">Order Images</div>
          <button onClick={onClose} className="px-2 py-1 text-sm">✕</button>
        </div>
        <div className="p-4">
          {images.length === 0 ? (
            <div className="text-sm text-gray-600">No images available.</div>
          ) : (
            <ul className="space-y-3">
              {images.map((img) => (
                <li key={img.id} className="border rounded p-3 flex items-center justify-between">
                  <div>
                    <div className="text-sm font-medium">{cap(img.image_type)} — {featureLabel(img.feature)}</div>
                    <div className="text-xs text-gray-500">{img.content_type}</div>
                  </div>
                  <div>
                    <Button size="sm" variant="secondary" onClick={() => onView(img)}>View</Button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {lightboxUrl && (
        <ImageLightbox url={lightboxUrl} contentType={lightboxType} onClose={() => setLightboxUrl(null)} />
      )}
    </div>
  );
};


